import React from 'react';
import { Button, TableCell } from '@mui/material';

interface MoreWeeksButtonProps {
  onClick: () => void;
  showMore: boolean;
}

export const MoreWeeksButton: React.FC<MoreWeeksButtonProps> = ({ onClick, showMore }) => (
  <TableCell align="center" sx={{ p: 2 }}>
    <Button
      onClick={onClick}
      variant="contained"
      size="small"
      color={showMore ? "error" : "primary"}
      sx={{ fontSize: '12px', fontWeight: 600 }}
    >
      {showMore ? '← Hide' : 'More →'}
    </Button>
  </TableCell>
);

interface TabButtonProps {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
  isMobile?: boolean;
}

export const TabButton: React.FC<TabButtonProps> = ({ active, onClick, children, isMobile = false }) => (
  <button
    onClick={onClick}
    style={{
      padding: isMobile ? '8px 12px' : '10px 16px',
      border: 'none',
      backgroundColor: active ? '#2563eb' : 'transparent',
      color: active ? 'white' : '#6b7280',
      borderRadius: '6px',
      cursor: 'pointer',
      fontWeight: active ? '600' : '500',
      fontSize: isMobile ? '12px' : '14px',
      transition: 'all 0.2s',
      whiteSpace: 'nowrap',
      flexShrink: 0,
      minWidth: 'fit-content'
    }}
  >
    {children}
  </button>
);

interface LoadingSpinnerProps {
  message?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message = 'Loading...' }) => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '24px'
  }}>
    <div style={{
      display: 'flex',
      gap: '8px'
    }}>
      {[0, 1, 2].map(i => (
        <div
          key={i}
          style={{
            width: '12px',
            height: '12px',
            backgroundColor: '#3b82f6',
            borderRadius: '50%',
            animation: `bounce 1.4s ease-in-out ${i * 0.16}s infinite both`
          }}
        />
      ))}
    </div>
    <div style={{ textAlign: 'center' }}>
      <h3 style={{
        fontSize: '18px',
        fontWeight: '600',
        color: '#1f2937',
        margin: '0 0 8px 0'
      }}>Loading</h3>
      <p style={{
        fontSize: '14px',
        color: '#6b7280',
        margin: 0
      }}>{message}</p>
    </div>
    <style>
      {`
        @keyframes bounce {
          0%, 80%, 100% {
            transform: scale(0);
          }
          40% {
            transform: scale(1);
          }
        }
      `}
    </style>
  </div>
);